import React, { useEffect } from 'react';
import {
    ActionsWrapper,
    SlipsWrapper,
    StyledButton,
    StyledText,
} from 'features/Betslip/styled';
import { clearMarks, setValidState } from 'components/big9/actions';
import { connect } from 'react-redux';
import { couponValidation } from 'utils/Big9BetslipHelper';
import TableContent from 'features/Betslip/TableContent';
import { isTerminal } from '../../utils/UiHelper';
import useTweaks from 'features/SpilKlub/state/useTweaks';

const BetSlipInfo = ({
    onSubmit = () => {},
    onClear = () => {},
    clearMarks,
    setValidState,
    outcomes,
    formattedMarks,
    wildcard,
    initialCouponItems,
    validState,
    spilklubMode,
    spilklubPoolWithCouponMode = false,
    payAndPlay = () => {},
    terminalSession,
    disablePrintBuyButtonTerminal = false,
    disableBuyButton = false,
    combinationPrice,
}) => {
    const { disablePoolWithCoupon } = useTweaks();
    const submit = () => {
        onSubmit();
    };

    const clearCouponData = () => {
        clearMarks();
        window.localStorage.removeItem('BIG9_Coupon');
        spilklubPoolWithCouponMode && disablePoolWithCoupon();
    };

    useEffect(
        () => {
            if (formattedMarks) {
                setValidState(
                    couponValidation(formattedMarks, wildcard, combinationPrice)
                );
            }
        },
        [formattedMarks]
    );

    return (
        <SlipsWrapper>
            {initialCouponItems.map((item, index) => (
                <TableContent item={item} key={index} outcomes={outcomes} />
            ))}
            <ActionsWrapper>
                {!terminalSession?.fetched && isTerminal() ? (
                    <StyledButton
                        margin="16px auto"
                        fontSize="14px"
                        fontWeight="bold"
                        width="70%"
                        onClick={payAndPlay}
                        color={'#333333'}
                        active
                        disabled={
                            !validState?.status || disablePrintBuyButtonTerminal
                        }
                    >
                        Print kupon
                    </StyledButton>
                ) : (
                    <StyledButton
                        margin="16px auto"
                        fontSize="14px"
                        fontWeight="bold"
                        width="70%"
                        onClick={submit}
                        color={'#333333'}
                        active
                        disabled={
                            (!validState?.status &&
                                !spilklubPoolWithCouponMode) ||
                            disableBuyButton
                        }
                    >
                        {spilklubPoolWithCouponMode
                            ? 'Tilføj til SpilKlub25'
                            : spilklubMode
                                ? 'Opdatere udkast'
                                : 'Placer spil'}
                    </StyledButton>
                )}
                <StyledText
                    onClick={() => {
                        onClear();
                        setTimeout(() => {
                            clearCouponData();
                        }, 200);
                    }}
                    bold
                    condensed
                    size="x1"
                    color="#333333"
                    padding="0"
                    align="center"
                >
                    Ryd kuponen
                </StyledText>
            </ActionsWrapper>
        </SlipsWrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        outcomes: state.big9.couponData.outcomes,
        wildcard: state.big9.couponData.wildcard,
        formattedMarks: state.big9.formattedMarks,
        initialCouponItems: state.big9.initialCouponItems,
        validState: state.big9.validState,
        terminalSession: state.terminalSession,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearMarks: () => {
            dispatch(clearMarks());
        },
        // validateCoupon: () => {
        //     dispatch(validateCoupon());
        // },
        setValidState: (validationState) => {
            dispatch(setValidState(validationState));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BetSlipInfo);
